import gql from 'graphql-tag';

export const SEARCH_FILES = gql`
  query searchFiles($idValue: String!) {
    SearchFiles(uri:$idValue) {
      id,
      uri
    }
  }
`;

export const GET_FILE = gql`
  query File(
    $id: ID,
    $proprietaryId: String,
    $fileName: String,
    $fileType: String,
    $uri: String,
    $hashSum: String,
    $hashAlgorithm: String,
    $hashVersion: String,
    $hashParameter: String,
    $hashDataType: String,
    $hashSumValue: String,
    $size: Int,
    $bitDepth: Int,
    $bitRate: Int,
    $samplingRate: Float,
    $codecType: String
  ) {
    File(
      id: $id,
      proprietaryId: $proprietaryId,
      fileName: $fileName,
      fileType: $fileType,
      uri: $uri,
      hashSum: $hashSum,
      hashAlgorithm: $hashAlgorithm,
      hashVersion: $hashVersion,
      hashParameter: $hashParameter,
      hashDataType: $hashDataType,
      hashSumValue: $hashSumValue,
      size: $size,
      bitDepth: $bitDepth,
      bitRate: $bitRate,
      samplingRate: $samplingRate,
      codecType: $codecType
    ) {
      id,
      proprietaryId,
      fileName,
      fileType,
      uri,
      hashSum,
      hashAlgorithm,
      hashVersion,
      hashParameter,
      hashDataType,
      hashSumValue,
      size,
      bitDepth,
      bitRate,
      samplingRate,
      codecType
    }
  }
`;

export const CREATE_FILE = gql`
  mutation createFile(
    $id: ID,
    $proprietaryId: String,
    $fileName: String,
    $fileType: String,
    $uri: String,
    $hashSum: String,
    $hashAlgorithm: String,
    $hashVersion: String,
    $hashParameter: String,
    $hashDataType: String,
    $hashSumValue: String,
    $size: Int,
    $bitDepth: Int,
    $bitRate: Int,
    $samplingRate: Float,
    $codecType: String
  ) {
    CreateFile(
      id: $id,
      proprietaryId: $proprietaryId,
      fileName: $fileName,
      fileType: $fileType,
      uri: $uri,
      hashSum: $hashSum,
      hashAlgorithm: $hashAlgorithm,
      hashVersion: $hashVersion,
      hashParameter: $hashParameter,
      hashDataType: $hashDataType,
      hashSumValue: $hashSumValue,
      size: $size,
      bitDepth: $bitDepth,
      bitRate: $bitRate,
      samplingRate: $samplingRate,
      codecType: $codecType
    ) {
      id,
      proprietaryId,
      fileName,
      fileType,
      uri,
      hashSum,
      hashAlgorithm,
      hashVersion,
      hashParameter,
      hashDataType,
      hashSumValue,
      size,
      bitDepth,
      bitRate,
      samplingRate,
      codecType
    }
  }
`;
export const UPDATE_COMPONENT_FILE = gql`
  mutation updateComponentFile(
      $personId: ID!,
      $projectId: ID!,
      $componentId: ID!,
      $fileInput: FileInput,
    ) {
      UpdateComponentFile(
        personId: $personId,
        projectId: $projectId,
        componentId: $componentId,
        fileInput: $fileInput,
      ) {
        id,
        uri,
        fileName,
        mimeType,
        fileType,
        size,
        bitDepth,
        samplingRate
      }
    }
`;

export const UPDATE_FILE = gql`
  mutation updateFile(
    $id: ID!,
    $proprietaryId: String,
    $fileName: String,
    $fileType: String,
    $uri: String,
    $hashSum: String,
    $hashAlgorithm: String,
    $hashVersion: String,
    $hashParameter: String,
    $hashDataType: String,
    $hashSumValue: String,
    $size: Int,
    $bitDepth: Int,
    $bitRate: Int,
    $samplingRate: Float,
    $codecType: String
  ) {
    UpdateFile(
      id: $id,
      proprietaryId: $proprietaryId,
      fileName: $fileName,
      fileType: $fileType,
      uri: $uri,
      hashSum: $hashSum,
      hashAlgorithm: $hashAlgorithm,
      hashVersion: $hashVersion,
      hashParameter: $hashParameter,
      hashDataType: $hashDataType,
      hashSumValue: $hashSumValue,
      size: $size,
      bitDepth: $bitDepth,
      bitRate: $bitRate,
      samplingRate: $samplingRate,
      codecType: $codecType
    ) {
      id,
      proprietaryId,
      fileName,
      fileType,
      uri,
      hashSum,
      hashAlgorithm,
      hashVersion,
      hashParameter,
      hashDataType,
      hashSumValue,
      size,
      bitDepth,
      bitRate,
      samplingRate,
      codecType
    }
  }
`;

export const DELETE_FILE = gql`
  mutation deleteFile (
    $id: ID!
  ) {
  DeleteFile(
    id: $id
  ) {
    id
  }
}
`;
